var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 29.7891C30 31.4922 29.5117 32.9531 28.5352 34.1719C27.5586 35.3906 26.3828 36 25.0078 36H4.99219C3.61719 36 2.44141 35.3906 1.46484 34.1719C0.488281 32.9531 0 31.4922 0 29.7891C0 28.4609 0.0664062 27.207 0.199219 26.0273C0.332031 24.8477 0.578125 23.6602 0.9375 22.4648C1.29688 21.2695 1.75391 20.2461 2.30859 19.3945C2.86328 18.543 3.59766 17.8477 4.51172 17.3086C5.42578 16.7695 6.47656 16.5 7.66406 16.5C9.71094 18.5 12.1562 19.5 15 19.5C17.8438 19.5 20.2891 18.5 22.3359 16.5C23.5234 16.5 24.5742 16.7695 25.4883 17.3086C26.4023 17.8477 27.1367 18.543 27.6914 19.3945C28.2461 20.2461 28.7031 21.2695 29.0625 22.4648C29.4219 23.6602 29.668 24.8477 29.8008 26.0273C29.9336 27.207 30 28.4609 30 29.7891ZM24 9C24 11.4844 23.1211 13.6055 21.3633 15.3633C19.6055 17.1211 17.4844 18 15 18C12.5156 18 10.3945 17.1211 8.63672 15.3633C6.87891 13.6055 6 11.4844 6 9C6 6.51562 6.87891 4.39453 8.63672 2.63672C10.3945 0.878906 12.5156 0 15 0C17.4844 0 19.6055 0.878906 21.3633 2.63672C23.1211 4.39453 24 6.51562 24 9Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.5d8485a544fcf06cbafd1293ce79ea4d.svg";
export { ForwardRef as ReactComponent };